export default __webpack_public_path__ + "images/gift-card-icon.f5c8dd50.svg";